import React from 'react'
import {Helmet} from "react-helmet";
import Header from '../component/Header'
import About from '../component/About'
import Services from '../component/Services'
import Courses from '../component/Courses'
import Statistics from '../component/Statistics'
import JoinUs from '../component/JoinUs'
export default function Home() {
    return (
        <>
            <Helmet>
                <title>Courses Hub</title>
            </Helmet>
            <Header/>
            <About/>
            <Services/>
            <Statistics/>
            <Courses/>
            <JoinUs/>
        </>
    )
}
